
export function getPlaceHolder(label: unknown, maxLen = 6) {
  if (typeof label === 'string') {
    return label.length > maxLen ? '请输入' : `请输入${label}`;
  }
  return '请输入';
}
